export const PATH = "https://store-template-server.vercel.app";

export const BASE__URL__API = `${PATH}/products`;
export const PATH__ITEM__PIZZAS = "pizza";
export const PATH__ITEM__DRINKS = "drinks";
export const PATH__ITEM__DESSERTS = "desserts";
export const PATH__ITEM__SIDE_DISHES = "side_dishes";

export const BASE__URL__USER = `${PATH}`;
export const POST__PATH__USER = `/register`;
export const GET__PATH__USER = `/login`;
